/**
 * splits price value into three-digit groups
 * */
export const formatPrice = (number: number): string =>
  typeof (number as any) === 'number' ?
    number
      .toFixed(0)
      .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1 ')
      .replace('.', ',')
  : '';

export const templateParser = (string: string, vars: Record<string, string>) => {
  if (!string) return '';
  if (!vars) return string;
  return string.replace(/{{(\w+)}}/gi, (full, match) => vars[match]);
};

export const formatPriceWithUnits = (
  value: number | string,
  vars: Record<string, string> = { currency: '₽' },
  template = '{{price}} {{currency}}',
) => {
  const price = typeof value === 'string' ? value : formatPrice(value);
  return templateParser(template, { price, ...vars });
};
